import { AuthContextValue } from '@shared/components/AuthProvider/AuthProvider.context';
import { EventUserStatus } from '@graphql/generated';

export const authToUserDetails = (auth: AuthContextValue) => {
  return {
    isLoggedIn: auth.isLoggedIn,
    ownedEventWebsite: auth.currentUser.eventMemberships?.find(event => event.status === EventUserStatus.owner)?.event?.website
  };
};
